export const state = () => ({
    demoElearnings: [],
    courseElearnings: []
})

export const mutations = {
    SET_DEMO_ELEARNINGS(state, demoElearnings) {
        state.demoElearnings = demoElearnings
    },
    SET_COURSE_ELEARNINGS(state, courseElearnings) {
        state.courseElearnings = courseElearnings
    }
}

export const actions = {
    async fetchElearnings(store) {
        const response = await this.$axios.$get('/api/e-learning')
        store.commit('SET_DEMO_ELEARNINGS', response.demos)
        store.commit('SET_COURSE_ELEARNINGS', response.courses)
    },

    async setViewed(store, { video, elearning }) {
        const updateElearningSections = (sections) => sections.map(section =>
            section.id !== video.section_id ? section : {
                ...section,
                videos: section.videos.map(v => ({
                    ...v,
                    viewed_by_user: v.id === video.id || v.viewed_by_user,
                }))
            }
        );

        const updateElearnings = (elearnings) => elearnings.map(e =>
            e.id !== elearning.id ? e : { ...e, elearning_sections: updateElearningSections(e.elearning_sections) }
        );

        store.commit('SET_DEMO_ELEARNINGS', updateElearnings(store.state.demoElearnings));
        store.commit('SET_COURSE_ELEARNINGS', store.state.courseElearnings.map(course => ({
            ...course,
            elearnings: updateElearnings(course.elearnings)
        })));
    },
}
